import JavaPluginActionNode from './customActionNode/index'
import InputNode from './inputNode'
import LLMNode from './llmNode'
import MessageNode from './messageNode/index'
import OutputNode from './outputNode'

export const NODE_TYPE = {
  LLMAction: LLMNode,
  JavaPluginAction: JavaPluginActionNode,
  MessageAction: MessageNode,
  input: InputNode,
  output: OutputNode,
}

export type NODE_TYPE_KEY = keyof typeof NODE_TYPE

export const ACTION_NODE = ['LLMAction', 'JavaPluginAction', 'MessageAction']
